import { render } from "./add-set.vue?vue&type=template&id=56964340&scoped=true"
import script from "./add-set.vue?vue&type=script&lang=js"
export * from "./add-set.vue?vue&type=script&lang=js"

import "./add-set.vue?vue&type=style&index=0&id=56964340&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56964340"]])

export default __exports__